import { apiClient } from '@copro/api';
import { useQuery } from '@tanstack/react-query';
import { Quote } from '../../../types';
import { keys } from './keys';

async function fetchQuotes(groupId: string): Promise<Quote[]> {
  const { data, error } = await apiClient
    .from('quotes')
    .select('*, quote_values (column_id, value)')
    .eq('group_id', groupId)
    .order('created_at');

  if (error) {
    throw error;
  }

  return data.map(({ quote_values, ...quote }) => ({
    ...quote,
    values: Object.fromEntries(quote_values.map((value) => [value.column_id, value.value ?? ''])),
  }));
}

export function useGetQuotes(groupId: string | undefined) {
  return useQuery({
    queryKey: keys.groupQuotes(groupId ?? ''),
    queryFn: () => fetchQuotes(groupId!),
    enabled: !!groupId,
  });
}
